<template>
    <div class="bg-white mt-56 md:mt-80 mb-20">
        <TransitionFade>
            <div v-if="isLoading">
                <div class="flex items-baseline justify-end md:justify-between p-4 lg:px-12 py-5 lg:py-3">
                    <div class="hidden md:block">
                        <div class="h-2.5 bg-gray-200 rounded-full w-24 mb-4"></div>
                    </div>
                    <div class="text-3xl lg:text-5xl font-semi-bold text-right">
                        <div class="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
                    </div>
                </div>
                <MoleculeCardEventSkeleton v-for="index in 5" :key="index"/>
            </div>
        </TransitionFade>

        <div v-if="!isLoading">
            <slot />
        </div>
    </div>
</template>

<script>
import TransitionFade from "../../../transitions/TransitionFade.vue";
import MoleculeCardEventSkeleton from "../../event/molecules/MoleculeCardEventSkeleton.vue";

export default {
    name: 'OrganismListContainer',
    components: {MoleculeCardEventSkeleton, TransitionFade},
    props: {
        isLoading: {
            type: Boolean
        }
    }
}
</script>
